<template>
  <div class="mt-8">
    <v-layout wrap>
      <v-flex>
        <!-- Snackbar -->
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>
          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <!-- Dialog Filter -->
        <v-dialog v-model="dialog.filter"
          @keydown.esc="dialog.filter = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title class="d-flex align-center pa-4 text-right popup-header">
              <div class="title font-weight-bold">Filter Data</div>
              <v-spacer/>
              <v-icon @click="dialog.fullscreen = !dialog.fullscreen ? true : false" class="cursor-pointer mr-1" size="24" :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>
              <v-icon @click="dialog.filter = false; dialog.fullscreen = false;" class="cursor-pointer" size="24" color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            <v-divider class="mb-2" style="border-top: 2px dashed #e0e0e0;"/>
            <v-card-text class="py-0 my-4">
              <v-select
                filled
                rounded
                dense
                :color="set_color"
                placeholder="Contoh. 2023"
                hide-details
                :items="years"
                :item-color="set_color"
                v-model="filter.year"
                style="border-radius: 10px;">
              </v-select>
            </v-card-text>
            <v-divider class="mt-2" style="border-top: 2px dashed #e0e0e0;"/>
            <v-card-actions class="pa-4">
              <v-spacer/>
              <v-btn @click="dialog.filter = false; fetch();" width="120" elevation="0" color="green" rounded class="body-2 font-weight-bold text-capitalize white--text">
                Filter
              </v-btn>
              <v-btn @click="dialog.filter = false" width="120" outlined elevation="0" color="red" rounded class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Dialog Form -->
        <v-dialog v-model="dialog.form"
          @keydown.esc="dialog.form = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title class="d-flex align-center pa-4 text-right popup-header">
              <div class="title font-weight-bold">Penyesuaian Stok</div>
              <v-spacer/>
              <v-icon @click="dialog.fullscreen = !dialog.fullscreen ? true : false" class="cursor-pointer mr-1" size="24" :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>
              <v-icon @click="dialog.form = false; dialog.fullscreen = false;" class="cursor-pointer" size="24" color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            <v-divider class="mb-2" style="border-top: 2px dashed #e0e0e0;"/>
            <v-card-text class="py-0 my-4">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <div>
                    <ValidationProvider
                      name="Nama Varian" 
                      rules="required" 
                      v-slot="{ errors }">
                      <div 
                        class="fs-15 label-input">
                        <span class="red--text">*</span>
                        Nama Varian
                      </div>

                      <v-autocomplete
                        v-on:keydown.enter.prevent="save()"
                        
                        filled
                        rounded
                        dense
                        solo

                        color="#718EBF"
                        placeholder="Pilih Varian"
                        v-on:change="form.varian_name = varian.find(item => item.id === form.varian_id).name; fetchStok(form.varian_id)""
                        
                        :items="varian"
                        item-value="id"
                        item-text="name"
                        :item-color="set_color"

                        v-model="form.varian_id"
                        :error-messages="errors"
                        required
                        style="border-radius: 10px;">
                      </v-autocomplete>
                    </ValidationProvider>
                  </div>
                  <div>
                    <ValidationProvider
                      name="Cabang"
                      rules="required"
                      v-slot="{ errors }">
                      <div class="fs-15 label-input">
                        <span class="red--text">*</span>
                        Cabang
                      </div>

                      <v-autocomplete
                        v-on:keydown.enter.prevent="save()"
                        
                        filled
                        rounded
                        dense
                        solo

                        color="#718EBF"
                        placeholder="Pilih Cabang"

                        
                        :items="cabang"
                        item-value="id"
                        item-text="name"
                        :item-color="set_color"

                        v-model="form.branch_id"
                        :error-messages="errors"
                        required
                        style="border-radius: 10px;">
                      </v-autocomplete>
                    </ValidationProvider>
                  </div>
                  <div>
                    <ValidationProvider
                      name="Jenis Penyesuaian"
                      rules="required"
                      v-slot="{ errors }">
                      <div class="fs-15 label-input">
                        <span class="red--text">*</span>
                        Jenis Penyesuaian
                      </div>

                      <v-autocomplete
                        v-on:keydown.enter.prevent="save()"
                        
                        filled
                        rounded
                        dense
                        solo

                        color="#718EBF"
                        placeholder="Pilih Jenis Penyesuaian"

                        
                        :items="[
                          { id: 'add', name: 'Stok Masuk' },
                          { id: 'subtract', name: 'Stok Keluar' }
                        ]"
                        item-value="id"
                        item-text="name"
                        :item-color="set_color"

                        v-model="form.type"
                        :error-messages="errors"
                        required
                        style="border-radius: 10px;">
                      </v-autocomplete>
                    </ValidationProvider>
                  </div>
                  <div>
                    <ValidationProvider
                      name="Jumlah Stok"
                      rules="required"
                      v-slot="{ errors }">
                      <div class="fs-15 label-input">
                        <span class="red--text">*</span>
                        Jumlah Stok Saat Ini <span class="grey--text fs-12">(Otomatis Terisi Ketika Pilih Varian)</span>
                      </div>
                      <v-currency-field
                        v-on:keydown.enter.prevent="save()"
                        
                        filled
                        rounded
                        dense
                        solo
                        readonly

                        color="#718EBF"
                        placeholder="Stok Saat Ini"
                        v-model="form.system_qty"
                        :error-messages="errors"
                        required
                        style="border-radius: 10px;">
                      </v-currency-field>
                    </ValidationProvider>
                  </div>
                  <div>
                    <ValidationProvider
                      name="Jumlah Penyesuaian"
                      rules="required"
                      v-slot="{ errors }">
                      <div class="fs-15 label-input">
                        <span class="red--text">*</span>
                        Jumlah Penyesuaian
                      </div>
                      <v-currency-field
                        v-on:keydown.enter.prevent="save()"
                        
                        filled
                        rounded
                        dense
                        solo
                        color="#718EBF"
                        placeholder="Jumlah Penyesuaian"
                        v-model="form.adjust_qty"
                        :error-messages="errors"
                        required
                        style="border-radius: 10px;">
                      </v-currency-field>
                    </ValidationProvider>
                  </div>
                  <div>
                    <ValidationProvider
                      name="Keterangan"
                      rules="required"
                      v-slot="{ errors }">
                      <div class="fs-15 label-input">
                        <span class="red--text">*</span>
                        Keterangan
                      </div>
                      <v-textarea
                        v-on:keydown.enter.prevent="save()"
                        
                        filled
                        rounded
                        dense
                        solo
                        color="#718EBF"
                        placeholder="Keterangan"
                        v-model="form.note"
                        :error-messages="errors"
                        required
                        style="border-radius: 10px;">
                      </v-textarea>
                    </ValidationProvider>
                  </div>
                </v-form>
              </ValidationObserver>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                :color="'red'"
                @click="dialog.form = false"
                solo
                elevation="0"
                :disabled="process.form"
                :loading="process.form"
                class="text-capitalize white--text">
                Batal
              </v-btn>
              <v-btn
                :color="'#1814F3'"
                @click="save()"
                solo
                elevation="0"
                :disabled="process.form"
                :loading="process.form"
                class="text-capitalize white--text">
                Simpan
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Section dan Table -->
        <section>
          <v-card flat class="ma-4 mt-0 box-shadow pb-5" style="border-radius: 10px;">
            <v-row class="pa-4 py-0">
              <v-col cols="12" md="7">
                <span class="fs-16 black--text ml-2" style="font-weight: 600;">
                  Penyesuaian Stok
                </span>
              </v-col>
              <v-col cols="12" md="12" class="py-0">
                <v-row>
                  <v-col cols="12" md="2" sm="12" :class="rps !== 'xs' && rps !== 'sm' ? 'pr-0' : ''">
                    <v-btn
                      color="#4B4B4B"
                      elevation="0"
                      width="100%"
                      :disabled="process.load"
                      @click="dialog.form = true; reset()"
                      class="body-2 white--text text-capitalize d-flex align-center ml-0"
                      style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                      <v-icon size="20">mdi-plus-circle-multiple</v-icon>
                      
                      <span
                        class="ml-2">
                        Tambah
                      </span>
                    </v-btn>
                  </v-col>
                  <v-col cols="12" md="3" sm="12" :class="rps !== 'xs' && rps !== 'sm' ? 'pr-0' : ''">
                    <v-menu
                      ref="menu"
                      v-model="menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                      :close-on-click-outside="true"
                      @keydown.esc="closeDatePicker"
                      @click:outside="closeDatePicker"
                      class="ml-3"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          :value="formattedDate"
                          :color="set_color"
                          placeholder="dd/mm/yyyy"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          filled
                          rounded
                          dense
                          single-line
                          hide-details
                          clearable
                          @click:clear="clearDate"
                          @click="openDatePicker"
                          @keydown.enter="openDatePicker"
                          class="fs-12 little-placeholder"
                          style="border-radius: 6px; background: #d9e8ff9c !important; width: 100%;"
                        >
                          <template v-slot:append>
                            <v-icon :color="set_color" @click="openDatePicker" class="cursor-pointer">mdi-calendar</v-icon>
                          </template>
                        </v-text-field>
                      </template>
                      <v-date-picker
                        v-model="inputdatime"
                        :color="set_color"
                        @input="onDateChange"
                        locale="id"
                        :max="new Date().toISOString().substr(0, 10)"
                        :allowed-dates="allowedDates"
                        @click:date="onDateChange"
                      />
                    </v-menu>
                  </v-col>
                  <v-col cols="12" md="3" sm="12" :class="rps !== 'xs' && rps !== 'sm' ? 'pr-0' : ''">
                    <v-autocomplete
                      v-model="filter_varian"
                      :items="varian"
                      item-text="name"
                      item-value="id"
                      clearable
                      @click:clear="filter_varian = ''; fetch();"
                      hide-details
                      @change="fetch()"
                      filled
                      rounded
                      dense
                      class="fs-12 little-placeholder"

                      color="#718EBF"
                      placeholder="Pilih Varian"

                      
                      :item-color="set_color"
                      style="border-radius: 6px; background: #d9e8ff9c !important;">
                      <template v-slot:item="data">
                        <template>
                          <v-list-item-content class="fs-12">{{ data.item.name }}</v-list-item-content>
                        </template>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="3" sm="12" :class="rps !== 'xs' && rps !== 'sm' ? 'pr-0' : ''">
                    <v-autocomplete
                      v-model="filter_cabang"
                      :items="cabang"
                      item-text="name"
                      item-value="id"
                      clearable
                      @click:clear="filter_cabang = ''; fetch();"
                      hide-details
                      @change="fetch()"
                      filled
                      rounded
                      dense
                      class="fs-12 little-placeholder"

                      color="#718EBF"
                      placeholder="Pilih Cabang"

                      
                      :item-color="set_color"
                      style="border-radius: 6px; background: #d9e8ff9c !important;">
                      <template v-slot:item="data">
                        <template>
                          <v-list-item-content class="fs-12">{{ data.item.name }}</v-list-item-content>
                        </template>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <!-- <v-text-field
                  @click:clear="search = ''; fetch();"
                  v-on:keyup.enter="fetch()"
                  filled
                  rounded
                  dense
                  single-line
                  hide-details
                  :color="set_color"
                  placeholder="Cari data yang Anda butuhkan . . ."
                  append-icon="mdi-magnify"
                  clearable
                  v-model="search"
                  class="ml-3 fs-12 little-placeholder"
                  style="border-radius: 6px; background: #d9e8ff9c !important; max-width: 320px">
                </v-text-field> -->
              </v-col>
            </v-row>
            <v-card flat class="mt-0 mx-5" style="border-radius: 2px; border: 1px solid #E7E7E7;">
              <div class="view">
                <div v-if="!process.load" :class="process.load || list.length === 0 ? '' : 'wrapper'">
                  <table style="border-radius: 10px; width: 100%;" class="table">
                    <tr>
                      <th :class="rps !== 'xs' && rps !== 'sm' ? 'sticky-col one-col-penyesuaian' : ''" :style="rps !== 'xs' && rps !== 'sm' ? 'font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left; z-index: 2; width: 150px; min-width: 150px; max-width: 150px; cursor: pointer;' : 'font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left; cursor: pointer;'">
                        Tanggal
                      </th>
                      <th :class="rps !== 'xs' && rps !== 'sm' ? 'sticky-col second-col-penyesuaian' : ''" :style="rps !== 'xs' && rps !== 'sm' ? 'font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left; z-index: 2; width: 100px; min-width: 100px; max-width: 100px; cursor: pointer;' : 'font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left; cursor: pointer;'">
                        Nama Varian
                      </th>
                      <th style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left; cursor: pointer;">
                        No. Penyesuaian
                      </th>
                      <th style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left; cursor: pointer;">
                        Cabang
                      </th>
                      <th style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap; text-align: left;">
                        Jumlah Stok
                      </th>
                      <th style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap; text-align: left;">
                        Jumlah Penyesuaian
                      </th>
                      <th style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap; text-align: left;">
                        Jenis Penyesuaian
                      </th>
                      <th style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                        User Input
                      </th>
                    </tr>
                    <tr v-for="(item, index) in list" :key="index" @click="selected.row = index" :class="selected.row === index ? 'selected' : ''">
                      <td :class="rps !== 'xs' && rps !== 'sm' ? 'sticky-col one-col-penyesuaian' : ''" :style="rps !== 'xs' && rps !== 'sm' ? 'font-size: 12px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; width: 150px; min-width: 150px; max-width: 150px; white-space: nowrap; text-align: left; z-index: 1; background-color: white;' : 'font-size: 12px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;'">
                        {{ (item.date) | date }}
                      </td>
                      <td :class="rps !== 'xs' && rps !== 'sm' ? 'sticky-col second-col-penyesuaian' : ''" :style="rps !== 'xs' && rps !== 'sm' ? 'font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; width: 150px; min-width: 150px; max-width: 150px; white-space: nowrap; text-align: left; z-index: 1; background-color: white;' : 'font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;'">
                        {{ item.varian_name || '-' }}
                      </td>
                      <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;" class="text-capitalize">
                        {{ item.number || '-' }}
                      </td>
                      <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;" class="text-capitalize">
                        {{ item.branch_name || '-' }}
                      </td>
                      <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; width: 1px; white-space: nowrap; text-align: left;">
                        <div>
                          {{ item.system_qty | number }}
                        </div>
                      </td>
                      <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">
                        {{ item.adjust_qty | number }}
                      </td>
                      <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;" class="text-capitalize">
                        {{ item.type === 'add' ? 'Penambahan' : 'Pengurangan' }} Stok
                      </td>
                      <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; width: 250px; min-width: 250px; text-align: left;">
                        <div>
                          {{ item.input_user_name || '-' }}
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
                <v-card-text v-if="process.load" class="pb-0 my-4" style="height: calc(100vh - 350px); display: flex; align-items: center; justify-content: center;">
                  <div class="text-center">
                    <div class="mb-4 title">Mohon Tunggu . . .</div>
                    <v-progress-linear :color="set_color" indeterminate rounded height="10"></v-progress-linear>
                  </div>
                </v-card-text>
                <v-card-text v-if="list.length === 0 && !process.load" class="pb-0 my-4" style="height: calc( 100vh - 350px ); display: flex; align-items: center; justify-content: center;">
                  <div class="text-center">
                    <v-img class="mx-auto" contain alt="vuetify" :width="90" :height="90" :src="require('@/assets/image/empty.png')"></v-img>
                    <div class="mt-3 fs-16">Belum Ada Data</div>
                  </div>
                </v-card-text>
                <pagination v-if="!process.load && pagination.total_data > 0"
                  @changePage="fetch($event)" 
                  @reloadPage="fetch($event)" 
                  :model="pagination" :display="paginationList"/>
              </div>
            </v-card>
          </v-card>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { get, post, put, patch, destroy } from "@/service/Axios";
import moment from "moment"
import "moment/locale/id"

export default {
  data () {
    return {
      checkbox: false,
      dialog: {
        fullscreen: false,
        snackbar: false,
        filter: false,
        form: false,
      },
      search: '',
      filter_cabang: '',
      filter_varian: '',
      inputdatime: '', // Tidak ada default tanggal
      menu: false,
      sortBy: 'id',
      sortDesc: '-',
      filter: {
        year: new Date().getFullYear()
      },
      selected: {
        row: []
      },
      form: {
        variant_id: '',
        branch_id: '',
        system_qty: '',
        varian_name: '',
        adjust_qty: '',
        type: '',
        note: '',
      },
      options: {},
      list: [],
      cabang: [],
      varian: [],
      pagination: {},
      paginationList: {
        page: 1,
        row: 50
      },
      limit: 50,
      process: {
        load: false,
        form: false,
      },
      message: {
        success: '',
        error: ''
      }
    }
  },
  components: {
    pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination_other.vue')
  },
  watch: {
    'options': {
      handler () {
        let pagination = { row: this.limit, page: 1 }
        this.fetch(pagination)
      },
      deep: true
    },
    'inputdatime': {
      handler (newVal, oldVal) {
        if (newVal !== oldVal) {
          // Tanggal berubah, tutup menu
          this.menu = false
          // Fetch data jika ada tanggal
          if (newVal) {
            this.$nextTick(() => {
              this.fetch()
            })
          }
        }
      }
    }
  },
  computed: {
    rps () {
      return this.$vuetify.breakpoint.name
    },
    user () {
      return this.$store.state.user
    },
    set_color () {
      return this.$store.state.color
    },
    years () {
      let max = new Date().getFullYear()+2, min = max - 2, years = []
      for (let i = max; i >= min; i--) {
        years.push({
          text: i,
          value: i
        })
      }
      return years
    },
    // Format tanggal untuk ditampilkan
    formattedDate () {
      if (!this.inputdatime) return ''
      // inputdatime: 'YYYY-MM-DD'
      const [year, month, day] = this.inputdatime.split('-')
      return `${day}/${month}/${year}`
    }
  },
  mounted () {
    this.inputdatime = '' // Tidak ada default tanggal
    this.menu = false
    this.$nextTick(() => { this.fetch() })
    this.fetchCabang()
    this.fetchVarian()
  },
  methods: {
    // Method untuk menangani perubahan tanggal
    onDateChange() { 
      this.menu = false; 
    },
    // Method untuk clear tanggal
    clearDate() { 
      this.inputdatime = ''; 
      this.menu = false; 
      this.$nextTick(() => { this.fetch() }) 
    },
    // Method untuk membuka menu date picker
    openDatePicker() { 
      this.menu = true 
    },
    // Method untuk menutup menu date picker
    closeDatePicker() { 
      this.menu = false 
    },
    // Method untuk menentukan tanggal yang diizinkan
    allowedDates(val) {
      const today = new Date()
      const selectedDate = new Date(val)
      return selectedDate <= today
    },
    toSort(name) {
      this.sortBy = name
      this.sortDesc = ''
      this.fetch()
    },
    toDesc() {
      this.sortDesc === '-' ? this.sortDesc = '' : this.sortDesc = '-'
      this.fetch()
    },
    async fetchCabang() {

      let params = {
        limit: 10000000000000
      }

      await get(`admin/branch/data`, { params })
      .then(response => {
        let res = response.data
        
        if (res.status === 200) {
          this.cabang = res.results.data
        }
      })
    },
    async fetchVarian() {

      let params = {
        limit: 10000000000000
      }
      await get(`admin/varian/data`, { params })
      .then(response => {
        let res = response.data
        
        if (res.status === 200) {
          this.varian = res.results.data
        }
      })
    },

    async fetchStok(variant_id) {
      console.log(variant_id)

      let params = {
        limit: 10000000000000,
        varian_id: variant_id,
      }
      await get(`admin/item_stock/data`, { params })
      .then(response => {
        let res = response.data
        
        if (res.status === 200) {
          this.form.system_qty = res.results.data[0].saldo*1
        }
      })
    },
    async fetch (pagination = { row: 50, page: 1 }) {
      this.process.load = true

      this.limit = pagination.row
      this.paginationList = pagination

      // Format tanggal untuk API (yyyy-mm-dd)
      let formattedDate = ''
      if (this.inputdatime) {
        try {
          const date = new Date(this.inputdatime)
          if (!isNaN(date.getTime())) {
            formattedDate = this.inputdatime
          }
        } catch (error) {
          formattedDate = ''
        }
      }

      let params = {
        limit: pagination.row,
        page: pagination.page,
        sort: `${this.sortDesc}${this.sortBy}`,
        search: this.search,
        date: formattedDate,
        varian_id: this.filter_varian,
        branch_id: this.filter_cabang,
      }

      this.selected.row = []
      
      await get(`admin/stock_adjustment/data`, { params })
      .then(response => {
        let res = response.data
        
        this.process.load = false
        
        this.list = []
        this.pagination = {}
        
        if (res.status === 200) {
          this.list = res.results.data
          this.pagination = res.results.pagination
        }
      })
    },
    reset() {
      if (this.$refs.form) this.$refs.form.reset()
      this.form = {
        variant_id: '',
        branch_id: '',
        system_qty: '',
        varian_name: '',
        adjust_qty: '',
        type: '',
        note: '',
      }

      this.process.form = false

      this.message.error = ''
    },
    async save () {
      this.message.error = ''

      const isValid = await this.$refs.form.validate()
      if (isValid) {
        this.process.form = true

        // SAVE TO REST API
        await post(`admin/stock_adjustment/adjust`, {
          data: this.form
        })
        .then((response) => {
          let res = response.data

          this.process.form = false

          if (res.status === 200) {

            this.dialog.form = false

            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.reset()

            this.fetch()
            

          } else {
            this.message.error = res.message
          }
        })
        
      } else {
        // AUTO FOCUS ON TEXT-FIELD
        setTimeout(() => {
          const errors = Object.entries(this.$refs.form.errors)
            .map(([key, value]) => ({ key, value }))
            .filter(error => error['value'].length)
          this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          })
        }, 10)
      }
    }
  }
}
</script>

<style>
  ::-webkit-scrollbar-thumb{
    border-radius: 10px;
    background-color: #718EBF;
  }
  table, th, td {
    border-spacing: 4px;
    border-collapse: collapse;
  }

  .view {
    margin: auto;
  }

  .wrapper { 
    overflow-y: auto; 
    height: calc(100vh - 310px); 
  } 

  .wrapper th { 
    position: sticky; 
    top: 0; 
    background-color: white !important;
  } 
  .sticky-col {
    position: -webkit-sticky;
    position: sticky;
    background-color: white !important;
  }

  .one-col-penyesuaian {
    width: 150px;
    min-width: 150px;
    max-width: 150px;
    left: 0px;
  }

  .second-col-penyesuaian {
    width: 150px;
    min-width: 150px;
    max-width: 150px;
    left: 150px;
  }

  .two-line {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.2em;
    max-height: 2.4em;
  }

  tr:hover {background-color: #1976d236;}
  tr.selected {background-color: #1976d236;}
</style> 